import Chrome from './Chrome';

export default Chrome;
